import withQueryClient from "~/helpers/withQueryClient";
import useBeardCounts from "../hooks/useBeardCounts";
import BeardNotificationsList from "../components/BeardNotificationsList";
import Loading from "~/components/Loading";

function NotificationsBeardContainer() {
    const queryClient = ReactQuery.useQueryClient()
    useBeardCounts({ 
        onSuccess: ( counts ) => {
            if (counts.notifications > 0) {
                queryClient.invalidateQueries(['beard', 'items', 'notifications'])
            }
        } 
    })

    const [isOpened, setIsOpened] = React.useState(false)

    const { data: notifications, isFetching: isNotificationsLoading, isError: isNotificationsError, isSuccess: isNotificationsLoaded } = ReactQuery.useQuery({
        queryKey: ['beard', 'items', 'notifications'],
        queryFn: () => accountAction.fetchNotifications(),
        enabled: isOpened,
        staleTime: 1000 * 60 * 5,
        onSuccess: () => {
            accountAction.notySetLastViewed().then(() => {
                queryClient.setQueryData(['beard', 'counts'], prev => ({...prev, notifications: 0}))
            })
        },
    })

    React.useEffect(() => {
        const disposeShowBeard = listenEvent("showNotificationsBeard", showNotificationsBeard)
        const disposeHideBeard = listenEvent("hideNotificationsBeard", hideNotificationsBeard)

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.push-wrapp, .logined-link').length) {
                raiseEvent('hideNotificationsBeard');
            }
        })

        $(document).on('keyup', function(e) {
            if (e.key === "Escape") {
                raiseEvent('hideNotificationsBeard');
            }
        });

        if (typeof SimpleBar === 'function')
            new SimpleBar($('#reactNotificationsBeard').closest('.push-bag')[0]);

        return () => {
            disposeShowBeard()
            disposeHideBeard()
        }
    }, [])

    React.useEffect(() => {
        if (isOpened) {
            $('#reactNotificationsBeard').closest('.push-bag').addClass('opened')
        } else {
            $('#reactNotificationsBeard').closest('.push-bag').removeClass('opened')
        }
    }, [isOpened])

    function showNotificationsBeard() {
        setIsOpened(true)
    }

    function hideNotificationsBeard() {
        setIsOpened(false)
    }

    return (
        <div className="push-scroll">
            <div className="push-wrapp">
                {isNotificationsLoading && <Loading active={true} absolute={false} />}
                {isNotificationsError && <span>Что-то пошло не так</span>}
                {isNotificationsLoaded && <BeardNotificationsList items={notifications.items} />}
            </div>
        </div>
    )
}

const domContainer = document.querySelector('#reactNotificationsBeard');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(withQueryClient(NotificationsBeardContainer)));
